import anipayService from 'app/pages/anipay/api/anipayService';
import {
  AniPayGetPayment,
  AniPayGetPaymentIban,
  AniPayMakePayment,
  AniPaySendOtp,
  CreateAniPayTemplate,
} from 'app/pages/anipay/model/types';
import { useMutation, useQuery } from 'react-query';

export const useGetCustomerType = () => {
  return useQuery('get_customer_type', () => anipayService.getCustomerType());
};

export const usePaymentFlow = () => {
  return useMutation((data: AniPayGetPayment) => anipayService.anipayPaymentFlow(data));
};

export const usePaymentFlowIban = () => {
  return useMutation((data: AniPayGetPaymentIban) => anipayService.anipayPaymentFlowIban(data));
};

export const useMakePayment = () => {
  return useMutation((data: AniPayMakePayment) => anipayService.anipayMakePayment(data));
};

export const useSignPayment = () => {
  return useMutation((data: { form_id: string; business_key: string }) =>
    anipayService.anipaySignPayment(data)
  );
};

export const useVerifyOtpPayment = () => {
  return useMutation((data: AniPaySendOtp) => anipayService.anipayVerifyOtpPayment(data));
};

export const useAniPayFileUpload = () => {
  const {
    mutate,
    isLoading,
    data: response,
  } = useMutation('ani-pay_file_upload', anipayService.uploadAniPayOrderFile);

  return {
    mutate,
    isLoading,
    response,
  };
};

export const useSaveTemplate = () => {
  return useMutation((data: CreateAniPayTemplate) => anipayService.anipaySaveTemplate(data));
};

export const useEditTemplate = () => {
  return useMutation((data: CreateAniPayTemplate) => anipayService.anipayEditTemplate(data));
};
